import { ExternalReference, SourceType } from 'graphql-query-contracts';

export type ReferenceItemErrorMessage = {
  sourceEntityId: string;
  sourceType: string;
};

export type ExternalReferenceItem = ExternalReference & {
  isRemovable: boolean;
  errorMessage: ReferenceItemErrorMessage;
};

// Type for external reference during editing - allows partial data
export type EditableExternalReference = Omit<ExternalReference, 'source'> & {
  source: {
    sourceEntityId: string | undefined;
    sourceEntityType: string | undefined;
    sourceType: SourceType | undefined;
  };
};

export type EditableExternalReferenceItem = EditableExternalReference & {
  isRemovable: boolean;
  errorMessage: ReferenceItemErrorMessage;
};

// Mapper functions to convert between editable and API types
export const mapEditableToExternalReference = (
  editable: EditableExternalReferenceItem
): ExternalReference | null => {
  if (!editable.source.sourceEntityId || !editable.source.sourceType) {
    return null;
  }

  return {
    id: editable.id,
    direct: editable.direct,
    source: {
      sourceEntityId: editable.source.sourceEntityId,
      sourceEntityType: editable.source.sourceEntityType || '',
      sourceType: editable.source.sourceType,
    },
    relationshipSource: editable.relationshipSource,
  };
};

export const mapExternalReferenceToEditable = (
  reference: ExternalReference
): EditableExternalReferenceItem => {
  return {
    id: reference.id,
    direct: reference.direct,
    source: {
      sourceEntityId: reference.source.sourceEntityId,
      sourceEntityType: reference.source.sourceEntityType,
      sourceType: reference.source.sourceType,
    },
    relationshipSource: reference.relationshipSource,
    isRemovable: true,
    errorMessage: {
      sourceEntityId: '',
      sourceType: '',
    },
  };
};

export const filterValidExternalReferences = (
  items: EditableExternalReferenceItem[]
): ExternalReference[] => {
  return items
    .map(mapEditableToExternalReference)
    .filter((ref): ref is ExternalReference => ref !== null);
};
